import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import useCustodianAccountNumberDispatch from '../../hooks/useCustodianAccountNumberDispatch';
import useIraApplicationFundingData from '../../hooks/useApplicationIraFundingData';
import { getValidationSchema } from '../../util/helpers/getValidationSchema';
import Back from '../Buttons/Back';
import { ModalHeading } from '../Modal';
import Paragraph from '../Paragraph/Paragraph';
import { FormWrap } from '../FormContainer/FormContainer';
import InputText from '../Fields/InputText';
import OnBoardingCta from '../OnBoarding/OnBoardingCta';
import themeColors from '../../assets/styles/themeColors';

const CustodianAccountNumber = ({
  handleNext,
  handleBack,
  setShouldClearForm,
}) => {
  const { t } = useTranslation();
  const {
    custodianAccountNumberDispatch,
  } = useCustodianAccountNumberDispatch();
  const { IraApplicationFundingResponse } = useIraApplicationFundingData();
  const { IRAFundingCustodianResponse } = IraApplicationFundingResponse;

  const formValidationSchema = Yup.object({
    ...getValidationSchema({
      fields: ['AccountNumber'],
    }),
  });

  const defaultValues = {
    AccountNumber: IRAFundingCustodianResponse?.AccountNumber,
  };

  const { handleSubmit, control } = useForm({
    resolver: yupResolver(formValidationSchema),
    defaultValues,
  });

  const onSubmit = ({ AccountNumber }) => {
    custodianAccountNumberDispatch({
      data: {
        AccountNumber,
      },
      defaultValues,
      onSuccess: handleNext,
    });
  };

  return (
    <>
      {handleBack && (
        <Back
          onClick={() => {
            handleBack();
            setShouldClearForm(true);
          }}
        />
      )}
      <ModalHeading>{t('iraCustodian.accountNumber.title')}</ModalHeading>
      <Paragraph mb={24} color={themeColors.colorTextXLLight}>
        {t('iraCustodian.accountNumber.description')}
      </Paragraph>
      <FormWrap>
        <Controller
          control={control}
          render={({ field, fieldState }) => (
            <InputText
              label={t('fields.labels.accountNumber')}
              {...field}
              {...fieldState}
              autoFocus
            />
          )}
          name="AccountNumber"
        />
        <OnBoardingCta type="submit" onClick={handleSubmit(onSubmit)} />
      </FormWrap>
    </>
  );
};

CustodianAccountNumber.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  setShouldClearForm: PropTypes.func,
};

export default CustodianAccountNumber;
